import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'


function Royalties() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              height:'100vh'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                    Royalties
                </div>



                <div className="infoDescHeader" style={{marginTop:'0em'}}>
                    PAYOUTS & MONETIZATION
                </div>

                <div className="infoDesc">
                At N3RVE, there are no middle men. Artists collect 100% of royalty distributions that are collected and sent out from the DSP platforms that host and their music.
                </div>

                {/* <div className="infoDesc">
                <br/>Artist Royalties are automatically calculated and distributed from each DSPs directly into the Wallet section of your user account. The wallet is accessible through your dashboard and provides all of the relevant data and payout information for each stream of revenue. 
                </div> */}

                <div className="infoDescHeader">
                REPORTS
                </div>

                <div className="infoDesc">
                Revenue and payout analytics can be filtered, and each pay period is tied to a downloadable statement with your royalty reports to keep on hand for your records.
                </div>

                <div className="infoDesc">
                <br/>If you have any questions regarding royalties or payouts, please reach out via our contact us page for further assistance. 
                </div>

                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default Royalties;